// Persistent random device ID for the context add-on (PLAN-Device-Context.md
// §B4.4). Random, so two phones of the same model never collide. Stored in
// localStorage and a host-only cookie (no Domain attribute): each tenant
// subdomain gets its own ID, and the browser never shares one across tenants.
//
// Incognito or cleared storage simply produce a new ID; Safari may also drop
// script-written storage after 7 days without visits. That's fine: a repeated
// ID is evidence, a new one is no evidence either way.

const KEY = 'inm_device_id';
const MAX_AGE_SECONDS = 60 * 60 * 24 * 400; // browsers cap cookie lifetime at ~400 days

function readCookie(): string | undefined {
  const match = document.cookie.match(new RegExp(`(?:^|; )${KEY}=([A-Za-z0-9_-]{8,64})`));
  return match?.[1];
}

export function getDeviceId(): string | undefined {
  let id: string | undefined;
  try {
    id = localStorage.getItem(KEY) || undefined;
  } catch {
    // storage blocked
  }
  id = id || readCookie();
  if (!id) {
    try {
      id = `dev_${crypto.randomUUID()}`;
    } catch {
      return undefined;
    }
  }
  try {
    localStorage.setItem(KEY, id);
  } catch {
    // storage blocked
  }
  try {
    document.cookie = `${KEY}=${id}; Max-Age=${MAX_AGE_SECONDS}; Path=/; Secure; SameSite=Lax`;
  } catch {
    // cookies blocked
  }
  return id;
}
